import { Controller } from '@hotwired/stimulus'
import React from 'react'
import { createRoot } from 'react-dom/client'
import CoachChatButton from '../components/coach_chat/CoachChatButton'

export default class extends Controller {
  static targets = ['container']
  static values = {
    socketUrl: String,
    username: String,
    avatar: String,
    chatRoom: String,
    inHours: Boolean,
    logChatEventPath: String,
    chatCoachInfoPath: String,
    serverTime: Number,
    currentUserLocale: String,
    userDisplayName: String,
    userFirstName: String,
    videoEnabled: Boolean,
    browserName: String,
    userLocale: String,
    userLanguage: String,
    userCompany: String,
    userCompanyId: String,
    partnerCandidate: Boolean,
    conversationStarter: String,
    chatMode: String,
    coachEasyRtcId: String,
    userId: Number,
    userEmail: String,
    os: String,
    buildChatHistoryPath: String,
    conversationId: String,
    isMobile: Boolean,
    clientTime: Number,
    timeOffset: Number,
    deloitteUser: Boolean,
    userCareerDevelopment: Boolean,
    outplacement: Boolean,
    opRedesign: Boolean,
    supportEmail: String,
    chatHours: String,
    hideChatHours: Boolean,
    modalCopy: Object,
  }

  connect() {
    // Wait for easyrtc to be available before initializing React
    this.waitForEasyRTC()
  }

  disconnect() {
    // Clean up React root if it exists
    if (this.reactRoot) {
      this.reactRoot.unmount()
    }
  }

  async waitForEasyRTC() {
    // Wait for openEasyRtc to be loaded and available on window
    // I only saw it wait once, this is more about bridging `require` and npm dependencies
    while (!window.openEasyRtc) {
      await new Promise((resolve) => setTimeout(resolve, 100))
    }

    // Now initialize the React component
    this.initializeReactComponent()
  }

  initializeReactComponent() {
    // Create React root and render the component
    this.reactRoot = createRoot(this.containerTarget)

    const props = {
      current_user: { locale: this.currentUserLocaleValue },
      socketUrl: this.socketUrlValue,
      username: this.usernameValue,
      avatar: this.avatarValue,
      chatRoom: this.chatRoomValue,
      inHours: this.inHoursValue,
      log_chat_event_path: this.logChatEventPathValue,
      chatCoachInfoPath: this.chatCoachInfoPathValue,
      serverTime: this.serverTimeValue,
      userDisplayName: this.userDisplayNameValue,
      userFirstName: this.userFirstNameValue,
      videoEnabled: this.videoEnabledValue,
      browserName: this.browserNameValue,
      userLocale: this.userLocaleValue,
      userLanguage: this.userLanguageValue,
      userCompany: this.userCompanyValue,
      userCompanyId: this.userCompanyIdValue,
      partnerCandidate: this.partnerCandidateValue,
      conversationStarter: this.conversationStarterValue,
      chatMode: this.chatModeValue,
      coachEasyRtcId: this.coachEasyRtcIdValue,
      userId: this.userIdValue,
      userEmail: this.userEmailValue,
      os: this.osValue,
      buildChatHistoryPath: this.buildChatHistoryPathValue,
      conversationId: this.conversationIdValue,
      isMobile: this.isMobileValue,
      clientTime: this.clientTimeValue,
      timeOffset: this.timeOffsetValue,
      deloitteUser: this.deloitteUserValue,
      userCareerDevelopment: this.userCareerDevelopmentValue,
      outplacement: this.outplacementValue,
      opRedesign: this.opRedesignValue,
      supportEmail: this.supportEmailValue,
      chatHours: this.chatHoursValue,
      hideChatHours: this.hideChatHoursValue,
      modalCopy: this.modalCopyValue,
    }

    this.reactRoot.render(React.createElement(CoachChatButton, props))
  }
}
